import { urlHash } from '../../../constants';
import { FilterValuesStrings } from '../pages/dashboard.page';
import CryptoJS from 'crypto-js';

export const generatePublicDashboardLink = (filters: FilterValuesStrings): string => {
	const filtersStr = JSON.stringify(filters);
	const encrypted = CryptoJS.AES.encrypt(filtersStr, urlHash).toString();

	return `${window.location.origin}/dashboard/public?data=${encodeURIComponent(encrypted)}`;
};
export const decryptFiltersFromQuery = (encryptedData: string): FilterValuesStrings | null => {
	try {
		const bytes = CryptoJS.AES.decrypt(decodeURIComponent(encryptedData), urlHash);
		const decryptedStr = bytes.toString(CryptoJS.enc.Utf8);
		if (!decryptedStr) return null;
		return JSON.parse(decryptedStr);
	} catch (e) {
		console.error('Failed to decrypt filters:', e);
		return null;
	}
};
